<template>
	<div class="phhomecc" id="phhomecca">
		<div class="videopop" v-if="popnos">
			<div class="videopopcont">
				<video controls autoplay :src="popcont"></video>
				<div class="el-icon-circle-close closevi" @click="pupclose()"></div>
			</div>

		</div>
		<el-backtop ></el-backtop>
		<div class="homecc-banner">
			<div class="bannerimg">
				<img @load="getimg()" :src="pcbanimg" />
			</div>
			<hpheader ></hpheader>
			<!-- <hpscorhea v-if="!socrollhea"></hpscorhea> -->
			<transition  enter-active-class="fadeInLeft">
				<div class="banner-foo" :class="chaece?'checse':''">
					<div class="babberfoo-hea">
						{{first_product_list['name']}}
					</div>
					<div class="babberfoo-foo">
						{{first_product_list['name_content']}}
					</div>
					<div class="babberfoo-but bg" :class="$store.state.brand" @click="natdetailsto(bannproid)" >
						{{redirmore}}
					</div>
				</div>
			</transition>
		</div>
<!--		<div class="homecc-bigpro" v-for="(item,index) in senpcproductcont" :id="'id'+item.product_id">-->
<!--			<div class="bigpro-hea" @click="natdetailsto(item.product_id)">-->
<!--				<img :src="item.second_image" />-->
<!--			</div>-->
<!--			<div class="bigpro-foo" :class="{bigproim:true,bigproimter:item.mess1}">-->

<!--				<div class="bigprofoo-model">-->
<!--					{{item.second_product_list.name}}-->
<!--&lt;!&ndash;					{{item.second_product_list.name_content}}&ndash;&gt;-->
<!--				</div>-->
<!--				<div class="bigprofoo-hea">-->
<!--					{{item.second_product_list.name_content}}-->
<!--				</div>-->
<!--				<div class="bigprofoo-but bg" :class="$store.state.brand" @click="natdetailsto(item.product_id)" >-->
<!--					{{redirmore}}-->
<!--				</div>-->
<!--			</div>-->
<!--		</div>-->
		<!--		大咖秀 start -->
		<div class="part-title">Top Talk</div>
		<div class="homecc-bigpro"  id="bigStar" v-if="showBigStar">
			<div class="bigpro-hea" >
				<iframe v-if="bigShot.isPlay" class="you-video" :src="bigShot.data.video" :title="bigShot.data.en_title" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
				<div v-else @click="playVideo(bigShot.data.video_id)" class="poster">
					<img class="play" src="../../assets/common/img/play.png" alt="">
					<img :src="bigShot.data.poster"  />
				</div>
			</div>
			<div class="bigpro-foo" :class="{bigproim:true,bigproimter: bigStar.mess1}">
<!--								<div class="bigprofoo-hea">-->
<!--									{{ bigShot.data.title }}1-->
<!--								</div>-->
				<div class="bigprofoo-model">
					{{ bigShot.data.title }}
				</div>
<!--								<div class="bigprofoo-hea">-->
<!--									{{ bigShot.data.description }}-->
<!--								</div>-->
				<div class="operate">
					<div class="bigprofoo-but"  :style="'background:' + $store.state.themeColor" >
						Learn more
					</div>
					<div class="bigprofoo-but"  :style="'background:#fff;color:'+$store.state.themeColor+';border:1px solid '+$store.state.themeColor" @click="toBigList">
						View all
					</div>
				</div>
			</div>
		</div>
		<!--		大咖秀 end -->

		<div class="part-title">Star Products</div>
		<div class="homecc-mainpro">
			<div class="mainpro-item" v-for="(item,index) in bigpcproductticont"  :id="'minid'+item.product_id">
				<div class="mainpro-hea" @click="natdetailsto(item.product_id)">
					<img :src="item.product_image" />
				</div>
				<div class="mainpro-foo" :class="{mainproim:true,mianproimter:item.mess1}">
					<div class="mainprofoo-hea">
						{{item.product_data_list.name}}
					</div>
					<div class="mainprofoo-foo">
						{{item.product_data_list.name_content}}
					</div>
					<div class="mainprofoo-but bg" :class="$store.state.brand" @click="natdetailsto(item.product_id)" >
						{{redirmore}}
					</div>
				</div>
			</div>
		</div>

		<div class="part-title latest-news">
			<div>LATEST NEWS</div>
			<div class="more" @click="toNews()">More <i class="el-icon-arrow-right"></i> </div>
		</div>
		<div class="news-list" v-if="showTabs">
			<ly-tabs v-model="value">
				<div class="item " v-for="(item,index) in newsList.list" ref="newsItem" :style="{width:newsList.item.width + 'px'}" style="box-shadow: 0 4px 8px 0 rgba(0,0,0,.1);border-radius: 10px;" @click="toNewsDetail(item)">
					<div class="item-container">
						<div
								class="item-box"
								:class="item.animation ? 'on' : ''"
						>
							<div class="image">
								<img :src="item.thumb" alt="">
							</div>
							<div class="text">
								<h3>{{ item.en_title }}</h3>
								<div class="desc">
									<p>
										{{ item.en_description }}
									</p>
									<i class="el-icon-right"></i>
								</div>
							</div>
						</div>
					</div>
					<!--					<i class="line"></i>-->
				</div>
			</ly-tabs>
		</div>



<!--		<el-carousel class="car-weiper" >-->
<!--		    <el-carousel-item  v-for="(item,index) in videopcproduct" :key="index" class="carweiper-item">-->
<!--				<div class="homecc-video">-->
<!--					<div class="video-hea">-->
<!--						<video   :src="item.videos" :poster="item.videos_image"></video>-->
<!--						<div class="phhovideobut" @click=popvideoc(item.videos)>-->
<!--							<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pchomeplay.svg" />-->
<!--						</div>-->
<!--					</div>-->
<!--					<div class="video-foo">-->
<!--						<div class="videofoo-hea">-->
<!--							{{item.videos_title}}-->
<!--						</div>-->
<!--						<div class="videofoo-foo">-->
<!--							{{item.videos_mark}}-->
<!--						</div>-->
<!--						<div class="bigprofoo-but bg" :class="$store.state.brand"  >{{redirmore}}</div>-->
<!--					</div>-->
<!--				</div>-->
<!--			</el-carousel-item>-->
<!--		</el-carousel>-->
		<div class="homecc-conte">
			<div class="conte-create">
				<div class="create-hea">{{created}}</div>
				<div class="create-foo"  ref="testref">
					<!-- <div class="create-fooitem">
						<div class="create-itemimg">
							<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phhomeimg/patet1.png" />
						</div>
						<div class="create-itemhea">
							{{bird_created[0].max_title}}<span>{{oldValue}}</span>{{pometerm}}
						</div>
						<div class="create-itemfoo">
							{{bird_created[0].min_title}}<span>{{fotoldValue}}</span>{{pometerm}}
						</div>
					</div> -->
					<!-- <div class="create-fooitem">
						<div class="create-itemimg">
							<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phhomeimg/patet2.png" />
						</div>
						<div class="create-itemhea">
							{{bird_created[1].max_title}}<span>{{leftoldValue}}</span>{{pometerm}}
						</div>
						<div class="create-itemfoo">
							{{bird_created[1].min_title}}<span>{{leftfotoldValue}}</span>{{pometerm}}
						</div>
					</div> -->
					<div class="create-fooitem">
						<div class="create-itemimg">
							<img src="../../assets/pchomeimg/pchomeadon.svg" />
						</div>
						<div class="text-container">
							<div class="create-itemhea" >
								<span :style="'color:'+$store.state.themeColor">{{tacoldValue}}</span>authorized Chinese patents
							</div>
							<div class="create-itemfoo" >
								<span :style="'color:'+$store.state.themeColor">{{fottacoldValue}}</span>invention patents included
							</div>
						</div>
					</div>
					<div class="create-fooitem">
						<div class="create-itemimg">
							<img src="../../assets/pchomeimg/pchomeain.svg" />
						</div>
						<div class="text-container">
							<div class="create-itemhea">
								<span :style="'color:'+$store.state.themeColor">{{gighfotoldValue}}</span>authorized international patents
							</div>
							<div class="create-itemfoo">
								<span :style="'color:'+$store.state.themeColor">{{fotgighfotoldValue}}</span>invention patents included
							</div>
						</div>
					</div>
				</div>
			</div>
      <div class="phquerycont">
        <div class="phquerycont-banner">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20250721/b1768185b2a4ec4bd94b638437e64cd3.jpg" alt="">
        </div>
        <div class="phquerycont-txt">
          <div class="phquerycont-hea">{{anti.title}}</div>
          <div class="phquerycont-title">{{anti.describe}}</div>
          <!--			<div class="phquerycont-inputcont">-->
          <!--				<div class="phquerycont-input">-->
          <!--					<input :placeholder="tips" v-model="quersu"/>-->
          <!--					<div class="phquery-inputbut bg" @click="oponzmnqu()" :class="$store.state.brand">{{querysub}}</div>-->
          <!--				</div>-->
          <!--			</div>-->
          <div class="phquerycont-ftitle">{{anti.tips}}</div>
        </div>
      </div>
<!--			<div class="conte-query">-->
<!--				<div class="query-hea">{{anti.title}}</div>-->
<!--				<div class="query-foo">{{anti.describe}}</div>-->
<!--				<div class="query-seapbor">-->
<!--					<div class="query-seap">-->
<!--						<div class="seap-input">-->
<!--							<input v-model="quersu" :placeholder="anti.tips" />-->
<!--						</div>-->
<!--						<div class="seap-but bg" :class="$store.state.brand" @click="oponzmnqu()" >-->
<!--							{{anti.btn}}-->
<!--						</div>-->
<!--					</div>-->
<!--				</div>-->
<!--			</div>-->
			<div class="conte-support">
				<div class="support-hea">
					{{get_more}}
				</div>
				<div class="support-item">
					<div class="support-foo" v-for="(item,index) in more" @click="navtoae(index)">
						<div class="supportfoo-img">
							<img :src="item.img" />
						</div>
						<div class="supportfoo-title">{{item.title}}</div>
					</div>
				</div>
			</div>
		</div>
		<hpfooter></hpfooter>
	</div>
</template>

<script>
	import hpfooter from '../../common/hpfooter.vue'
	import {session} from "../../storage/storage";
	import hpheader from '../../common/hpheader.vue'
	import hpscorhea from '../../common/hpscorhea.vue'
	import myVideo from '../../common/myvideo/img/myVideo.vue'
	import utils from '../../api/utils.js'

	export default{
		data(){
			return{
				showBigStar:false,
				showTabs:false,
				bigStar:{
					mess1:false
				},
				value: '0',
				quersu:'',
				id:'',
				popcont:'',
				popnos:false,
				tohomevid:false,
				socrollhea:false,
				navheader:false,
				heshow:false,
				show: false,
				playli:true,
				playri:true,
				testShow:false,
				testShowbig:false,
				pometerm:'项',
				oldValue:0,
				fotoldValue:0,
				leftoldValue:0,
				leftfotoldValue:0,
				tacoldValue:0,
				fottacoldValue:0,
				gighfotoldValue:0,
				fotgighfotoldValue:0,
				pcbanimg:'',
				bigpcproductti:'',
				senpcproduct:[],
				senpcproductcont:[],
				bigpcproductticont:[],
				videopcproduct:'',
				first_product_list:"",
				is_change: 0,
				bannproid:'',
				chaece:false,
				bird_created:[],
				created_data:{},
				newsList:{
					width:0,
					transform:0,
					residue:0,
					left:true,
					right:false,
					list:[],
					item:{
						width:0

					},

				},
				bigShot:{
					data:{},
					isPlay:false
				}
			}
		},
		created() {
			window.scrollTo(0,0);

			// this.ress()
			this.pchomeprod()
			this.pageParam()
			if (!(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {

				this.$router.push({path:'./pchome'})
				return
			}
			this.ress()
		},
		mounted() {

			// this.$refs.myVideo.onPlayerPlay()
			window.addEventListener("scroll", this.handleScroll)


			this.getBigStar()

			this.getNewList()

			this.setNews()

		},
		components:{
			hpfooter,
			hpscorhea,
			hpheader,
			myVideo
		},
		methods:{
			toNews(){
				this.$router.push({path: '/ph-news'})
			},
			playVideo(videoId){
				this.bigShot.data.video = this.getYouUri(videoId)
				this.bigShot.isPlay = true
			},
			learnMore(videoId){
				window.open(utils.getYouUrl(videoId))
			},
			getYouUri(videoId){
				return utils.getYouUri(videoId)
			},
			toNewsDetail(item){
				this.$router.push({path:'ph-news-detail',query:{id:item.id}})
			},
			getBigStar(){
				this.$api.get_big_star_hot({
					lang: session.get("lang") == null ? 'en' : session.get("lang"),
					channel_id:  session.get("channel_id") == null ? 1 : session.get("channel_id"),
				}).then(res => {
					this.bigShot.data = res.data
					this.showBigStar = true
				})
			},
			getNewList(){
				this.$api.get_news_center_list().then(res => {
					res.data.data.forEach((item) => {
						item.animation = false
					})
					this.newsList.list = res.data.data
					this.showTabs = true
				})
			},
			toBigList(){
				this.$router.push({path: '/ph-big-star'})
			},
			setNews(){
				let screenWidth = window.innerWidth;
				this.newsList.item.width = (screenWidth / 3) * 2
			},
			getimg(){
				this.chaece=true
			},
			pupclose(){
				this.popnos=false
			},
			natdetailsto(e){
				this.$router.push({path: '/phdetails',query:{e,type:'phone'}})
			},
			popvideoc(e){
				this.popcont=e
				this.popnos=true
			},
			navtoae(e){
				console.log(e)
				if(e==0){
					this.$router.push({path: '/phcontactus'})
				}else if(e==1){
					this.$router.push({path: '/phquerys'})
				}else if(e==2){
					this.$router.push({path: '/phcontactus'})
				}
			},
			handleScroll () {

			var domHight = document.body.offsetHeight;
			// dom滚动位置
			var scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			if(scroll!==0){
				this.socrollhea=true
			}
			// 获取监听元素
			var id;
			// 获取监听元素本身高度
			var scrollHeight;
			// 获取监听元素距离视窗顶部距离
			var offsetTop;
			// 获取监听元素距离顶部高度-窗口高度
			// this.senpcproductcont.map( (i) => {
			//   id = document.getElementById(`id${i.product_id}`);
			//   scrollHeight = id.scrollHeight;
			//   var offsetTop = id.offsetTop;
			//   // 页面滚动位置 > 元素距离顶部高度-窗口高度 && 页面滚动位置 < 元素距离顶部高度+元素本身高度
			//   if (scroll > offsetTop - 600) {
			//
			// 	for(let l=0;l<this.senpcproductcont.length;l++){
			// 		if(this.senpcproductcont[l].product_id==i.product_id){
			//
			// 			this.senpcproductcont[l].mess1=true
			// 		}
			// 	}
			//   } else {
			//
			//   }
			// });

				id = document.getElementById('bigStar');
				scrollHeight = id.scrollHeight;
				offsetTop = id.offsetTop;
				if (scroll > offsetTop - 500) {
					this.bigStar.mess1 = true
				}

			this.bigpcproductticont.map( (i) => {

			  id = document.getElementById(`minid${i.product_id}`);
			 let  mianscrollHeight = id.scrollHeight;
			  var mianoffsetTop = id.offsetTop;
			  // 页面滚动位置 > 元素距离顶部高度-窗口高度 && 页面滚动位置 < 元素距离顶部高度+元素本身高度
			  if (scroll > mianoffsetTop  - 300) {

				for(let l=0;l<this.bigpcproductticont.length;l++){
					if(this.bigpcproductticont[l].product_id==i.product_id){

						this.bigpcproductticont[l].mess1=true
					}
				}
			  } else {

			  }
			});
			let currentScroll = window.pageYOffset //表示当前滚动的位置

				 if (currentScroll >= this.$refs.testref.offsetTop - 600) { //当前滚动位置到达testref的时候，显示div（100作为调整用）
						this.testShow = true;
						let that = this;
							let timer = setInterval(function() {
								if (that.oldValue < that.created_data.apply_inner_num) {
							        that.oldValue++;
							    } else {
							        clearInterval(timer);
							    }
							}, 15);
							let fottimer = setInterval(function() {
								if (that.fotoldValue < that.created_data.apply_inner_num_fa) {
							        that.fotoldValue++;
							    } else {
							        clearInterval(fottimer);
							    }
							}, 60);
							let lefttimer = setInterval(function() {
								if (that.leftoldValue < that.created_data.apply_out_num) {
							        that.leftoldValue++;
							    } else {
							        clearInterval(lefttimer);
							    }
							}, 265);
							let leffotttimer = setInterval(function() {
								if (that.leftfotoldValue < that.created_data.apply_out_num_fa) {
							        that.leftfotoldValue++;
							    } else {
							        clearInterval(leffotttimer);
							    }
							}, 260);
							let tactimer = setInterval(function() {
								if (that.tacoldValue < that.created_data.get_inner_num) {
							        that.tacoldValue++;
							    } else {
							        clearInterval(tactimer);
							    }
							}, 20);
							let fottactimer = setInterval(function() {
								if (that.fottacoldValue < that.created_data.get_inner_num_fa) {
							        that.fottacoldValue++;
							    } else {
							        clearInterval(fottactimer);
							    }
							}, 265);
							let righfotttimer = setInterval(function() {
								if (that.gighfotoldValue < that.created_data.get_out_num) {
							        that.gighfotoldValue++;
							    } else {
							        clearInterval(righfotttimer);
							    }
							}, 260);
							let fotrighfotttime = setInterval(function() {
								if (that.fotgighfotoldValue < that.created_data.get_out_num_fa) {
							        that.fotgighfotoldValue++;
							    } else {
							        clearInterval(fotrighfotttime);
							    }
							}, 260);
				    }
				// if (currentScroll >= this.$refs.bigprotitle.offsetTop + 600 ) { //当前滚动位置到达bigprotitle的时候，显示div（100作为调整用）
				// 	this.testShowbig=true
				//     }
			    var scrollTop =  document.documentElement.scrollTop || document.body.scrollTop

				if(scrollTop!==0){
					this.navheader= true;

				}

			},
      pchomeprod(){
        let data = {
          mold: "h5",
          lang: session.get("lang") == null ? 'en' : session.get("lang"),
          channel_id:  session.get("channel_id") == null ? 1 : session.get("channel_id"),
        }
        this.$api.goFeedback(data).then((res) => {
			this.pcbanimg=res.data.first_image
			this.bigpcproductti=res.data.product_data
			this.bigpcproductticont=[]
			this.bigpcproductti.map(((item, index)=> {
				this.bigpcproductticont.push(Object.assign({},item,{mess1:false,mess2:8}))
			}))
			this.created_data = res.data.created
			this.senpcproduct=res.data.second_data
			this.senpcproductcont=[]
			this.senpcproduct.map(((item, index)=> {
            this.senpcproductcont.push(Object.assign({},item,{mess1:false,mess2:8}))
          }))
			this.videopcproduct=res.data.videos_data
			this.first_product_list = res.data.first_product_list
			this.bannproid=res.data.first_product_id
        });
      },
			navtomore(){
				this.$router.push({path: '/phmore'})
			},
			oponzmnqu(){
				/* let af=23682052 */
				let af=this.quersu
				/* window.location.href = 'URL'; */
				window.location.href="http://cx.glwoodpecker.com.cn:88/Wp/gl?af="+af;
			},
			ress(){
				var html = document.documentElement; //获取根元素
				var designWidth = 750; //设计稿宽度
				//html.clientWidth 视口宽度
				html.style.fontSize = html.clientWidth / designWidth * 100 + "px"; //设置字体大小
			},
      pageParam(){
        let lang =  session.get("lang");
        if (lang === "cn"){
          this.created = "啄木鸟创造"
          this.redirmore='了解更多'
          this.pometerm='项'
          this.get_more = "获取更多支持"
          this.bird_created =  [
            {'max_title':'已申请国内专利','max_val':521,'min_title':'其中发明专利','min_val':122,'img': 'https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phhomeimg/patet1.png'},
            {'max_title':'已获授权国内专利','max_val':254,'min_title':'其中发明授权专利','min_val':19,'img':'https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phhomeimg/patet2.png'},
            {'max_title':'已申请国际专利','max_val':13,'min_title':'其中发明专利','min_val':11,'img':'https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phhomeimg/patet3.png'},
            {'max_title':'已获授权国际专利','max_val':4,'min_title':'其中发明授权专利','min_val':2,'img':'https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phhomeimg/patet4.png'},
          ]

          this.anti = {
            title:"防伪查询",
            describe:"为了方便广大用户查询,我司于近期升级了防伪查询系统",
            tips:"请输入防伪码",
            btn:"提交"
          }
          this.more = [
              {"title":"地图定位",'img':require("../../assets/pchomeimg/pchomemap.svg")},
              {"title":"用户服务",'img':require("../../assets/pchomeimg/pchomeservice.svg")},
              {"title":"联系我们",'img':require("../../assets/pchomeimg/pccontactus.svg")},
          ]

        }else{
          this.created = "CREATION OF WOODPECKER"
          this.redirmore='Learn More'
          this.pometerm='term'
          this.get_more = "MORE SUPPORT"
          this.bird_created =  [
            {'max_title':'Applied for domestic patent','max_val':521,'min_title':'Including invention patent','min_val':122,'img':"https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phhomeimg/patet1.png"},
            {'max_title':'Authorized domestic patent','max_val':524,'min_title':'Among them, the invention is authorized patent','min_val':19,'img':"https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phhomeimg/patet1.png"},
            {'max_title':'International patent has been applied for','max_val':13,'min_title':'Including invention patent','min_val':11,'img':"https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phhomeimg/patet1.png"},
            {'max_title':'Authorized international patent','max_val':4,'min_title':'Among them, the invention is authorized patent','min_val':2,'img':"https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phhomeimg/patet1.png"},
          ]

          this.anti = {
            title:"Anti-Fake Inquiry",
            describe:"To verify product authenticity,please send the serial number directly to our official email:",
            tips:"woodpecker4@glwoodpecker.com",
            btn:"submit"
          }

          this.more = [
              {"title":"Map",'img':require("../../assets/pchomeimg/pchomemap.svg")},
              {"title":"Users Service",'img':require("../../assets/pchomeimg/pchomeservice.svg")},
              {"title":"Contact Us",'img':require("../../assets/pchomeimg/pccontactus.svg")},
           ]
        }
      },

		}
	}
</script>

<style>

	body{
		margin: 0;
		padding: 0;
	}
	.phhomecc{
		/* padding-top:  0.88rem; */
		width: 7.5rem;
		/* height: 100vh; */
		background: #FAFAFA;

	}
	.homecc-banner{
		width: 7.5rem;
		height: 11rem;
		position: relative;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
	}
	.banner-foo{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}
	.babberfoo-hea{
		font-size: 0.2rem;
		font-weight: normal;
		color: #FFFFFF;
		line-height: 0.26rem;
		letter-spacing: 0.01rem;
		margin-top: 0.8rem;
	}
	.babberfoo-model{
		font-size: 0.44rem;
		font-weight: normal;
		color: #FFFFFF;
		line-height: 0.58rem;
		letter-spacing: 0.02rem;
		margin-top: 0.24rem;
	}
	.babberfoo-foo{
		font-size: 0.44rem;
		font-weight: normal;
		color: #FFFFFF;
		line-height: 0.26rem;
		letter-spacing: 0.01rem;
		margin-top: 0.24rem;
	}
	.babberfoo-but{
		display: flex;
		align-items: center;
		justify-content: center;
		width: 1.46rem;
		height: 0.66rem;
		background: #E31E24;
		border-radius: 0.43rem;
		margin-top: 0.4rem;
		font-size: 0.16rem;
		font-weight: 400;
		color: #FFFFFF;
		line-height: 0.22rem;
	}
	.homecc-bigpro{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}
	.bigpro-hea{
		width: 6.9rem;
		/*height: 5.2rem;*/
		border-radius: 0.23rem 0.23rem 0 0;
	}
	.bigpro-hea img{
		width: 100%;
		height: 100%;
		border-radius:0.23rem 0.23rem 0 0;
	}
	.bigpro-foo{
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	.bigprofoo-hea{
		width: 90%;
		/* background: red; */
		text-align: center;
		font-size: 0.2rem;
		font-weight: normal;
		color: #5d5f5f;
		/*line-height: 0.26rem;*/
		/*letter-spacing: 0.01rem;*/
	}
	.bigprofoo-model{
		font-size: 0.44rem;
		font-weight: normal;
		color: #5d5f5f;
		line-height: 0.58rem;
		letter-spacing: 0.02rem;
		margin-top: 0.24rem;
	}
	.bigprofoo-foo{
		font-size: 0.2rem;
		font-weight: normal;
		color: #5d5f5f;
		line-height: 0.26rem;
		letter-spacing: 0.01rem;
		margin-top: 0.24rem;
	}
	.homecc-bigpro .bigpro-foo .operate {
		display: flex;
		justify-content: center;
		align-items: center;

	}
	.homecc-bigpro .bigpro-foo .operate .bigprofoo-but {

	}
	.homecc-bigpro .bigpro-foo .operate .bigprofoo-but:nth-child(2) {
		margin-left: .3rem;
	}
	.bigprofoo-but{
		display: flex;
		align-items: center;
		justify-content: center;
		width: 1.46rem;
		height: 0.66rem;
		background: #E31E24;
		border-radius: 0.43rem;
		margin-top: 0.4rem;
		font-size: 0.16rem;
		font-weight: 400;
		color: #FFFFFF;
		line-height: 0.22rem;
	}


	.homecc-mainpro{
		display: flex;
		flex-wrap: wrap;
		padding-left: 0.3rem;
		box-sizing: border-box;
	}
	.mainpro-hea{
		width: 3.3rem;
		height: 2.45rem;
		border-radius: 0.23rem 0.23rem 0 0 ;
	}
	.mainpro-hea img{
		width: 100%;
		height: 100%;
		border-radius: 0.23rem 0.23rem 0 0 ;
	}
	.mainpro-foo{
		padding-left: 0.2rem;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
	}
	.mainprofoo-hea{
		min-height: 0.8rem;
		font-size: 0.28rem;
		font-weight: 600;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
		margin-top: 0.21rem;
	}

	.mainprofoo-foo{
		font-size: 0.2rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #666666;
		line-height: 0.28rem;
		letter-spacing: 0.01rem;
		margin-top: 0.12rem;
		min-height: 0.8rem;

	}
	.mainprofoo-but{
		display: flex;
		align-items: center;
		justify-content: center;
		width: 1.46rem;
		height: 0.66rem;
		background: #E31E24;
		border-radius: 0.43rem;
		margin-top: 0.2rem;
		font-size: 0.16rem;
		font-weight: 400;
		color: #FFFFFF;
		line-height: 0.22rem;
	}
	.mainpro-item{
		width: 3.3rem;
		background-color: #FFFFFF;
		margin-right: 0.3rem;
		border-radius: 0.23rem;
		margin-bottom: 0.3rem;
		padding-bottom: 0.3rem;
	}
	.mainpro-item:nth-child(2n){
		margin-right: 0rem;
	}
	.homecc-video{
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		margin-top: 0.8rem;
	}
	.video-hea{
		width: 6.9rem;
		height: 3.88rem;
		border-radius: 0.23rem;
		position: relative;
	}
	.video-hea video{
		width: 100%;
		height: 100%;
		border-radius: 0.23rem;
	}
	.phhovideobut {
		width: 6.9rem;
		height: 3.88rem;
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		top: 0;
		left: 0;

	}
	.phhovideobut img{
		/* background-color: #fff; */
		width: 0.9rem;
		height: 0.9rem;
	}
	.video-foo{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}
	.videofoo-hea{
		font-size: 0.44rem;
		font-weight: normal;
		color: #5d5f5f;
		line-height: 0.58rem;
		letter-spacing: 0.02rem;
		margin-top: 0.4rem;
	}
	.videofoo-foo{
		font-size: 0.2rem;
		font-weight: normal;
		color: #5d5f5f;
		line-height: 0.26rem;
		letter-spacing: 0.01rem;
		margin-top: 0.24rem;
		margin-left: 0.3rem;
	}
	.homecc-conte{
	}
	.conte-create{
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
    padding-bottom: 1rem;
	}
	.create-hea{
		font-size: 0.4rem;
		font-weight: 600;
		color: #5d5f5f;
		line-height: 0.56rem;
		letter-spacing: 0.02rem;
		margin-top: 0.6rem;
	}
	.create-foo{
		display: flex;
		align-items: center;
		justify-content: center;
		flex-wrap: wrap;
		margin-top: 0.3rem;
	}
	.create-fooitem{
		/*display: flex;*/
		/*justify-content: flex-start;*/
		/*align-items: center;*/
		/*flex-direction: column;*/
		/*margin-right: 1.13rem;*/
		/*margin-top: .2rem;*/
	}
	.create-fooitem:nth-child(2n){
		/*margin-right: 0rem;*/
	}
	.create-itemimg{
		width: 0.9rem;
		height: 0.9rem;
	}

	.create-itemimg img{
		width: 100%;
		height: 100%;
	}
	.create-itemhea{
		font-size: 0.24rem;
		font-weight: 400;
		color: #5d5f5f;
		/*line-height: 0.34rem;*/
		/*letter-spacing: 0.01rem;*/
		/*margin-top: 0.24rem;*/
	}
	.create-itemhea span{
		color: #E31E24;
	}
	.create-fooitem{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 0.2rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #666666;
		/*line-height: 0.28rem;*/
		/*letter-spacing: 0.01rem;*/
		margin-top: 0.4rem;
	}
	.create-fooitem span{
		color: #E31E24;
	}
	.create-fooitem .text-container {
		padding-left: .2rem;
		width: 4.1rem;
	}
	.conte-query{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}
	.query-hea{
		font-size: 0.4rem;
		font-weight: 600;
		color: #5d5f5f;
		line-height: 0.56rem;
		letter-spacing: 0.02rem;
		margin-top: 0.8rem;
	}
	.query-foo{
		font-size: 0.2rem;
		font-weight: 400;
		color: #666666;
		line-height: 0.28rem;
		letter-spacing: 0.01rem;
		margin-top: 0.2rem;
		margin-left: 0.3rem;
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
	}
	.query-seapbor{
		margin-top: 0.4rem;
		background-color: #cccc;
		width: 6.9rem;
		height: 0.7rem;
		padding: 0.01rem;
		border-radius: 0.35rem;
	}
	.query-seap{

		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 6.9rem;
		height: 0.7rem;
		background: #FFFFFF;
		border-radius: 0.35rem;
		/* border: 0.01rem solid #CCCCCC; */
	}
	.seap-input{
		width: 5rem;
		height: 0.6rem;
		border-radius: 0.3rem;
		margin-left: 0.27rem;
		display: flex;
	}
	.seap-input input{
		border: none;
		width: 5rem;
		height: 0.5rem;
		outline: none;
		border-radius: 0.3rem;
		display: flex;
	}
	.seap-but{
		width: 1.1rem;
		height: 0.46rem;
		background: #E31E24;
		border-radius: 0.23rem;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 0.16rem;
		font-weight: 400;
		color: #FFFFFF;
		margin-right: 0.07rem;
	}
	.conte-support{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}
	.support-hea{
		font-size: 0.4rem;
		font-weight: 600;
		color: #5d5f5f;
		letter-spacing: 0.02rem;
		margin-top: 0.8rem;
	}
	.support-item{
		font-size: 0.2rem;
		display: flex;
		margin-top: 0.6rem;
		padding: 0 0.3rem;
		margin-bottom: 0.8rem;
		/* margin-left: 0.3rem;
		margin-right: 0.3rem; */
		color: #5d5f5f;
	}
	.support-foo{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;

		margin-left: 1.00rem;
	}
	.support-foo:first-child{
		margin-left: 0rem;
	}

	.checse{
		position: absolute;
		margin-top: 1.41rem;
		-webkit-animation-name: "fadeInLeft"; /*动画名称，需要跟@keyframes定义的名称一致*/
		-webkit-animation-duration: 1s;/*动画持续的时间长*/
		-webkit-animation-iteration-count: 1;/*动画循环播放的次数为1 infinite为无限次*/
	}
	.car-weiper{
		height: 8.8rem;
		margin-top: 0.4rem;
		background: #FFFFFF;
	}
	.carweiper-item{
		height: 8.8rem;
		background: #FFFFFF;
	}
	.swiper-cont{
		height: 8.8rem;
		display: flex;
		flex-direction: column;
	}
	.el-carousel__indicators--horizontal{
		display: none;
	}
	.bannerimg{
		position: absolute;
		top: 0;
		left: 0;
		width: 7.5rem;
		height: 11rem;
	}
	.bannerimg img{
		width: 100%;
		height: 100%;
	}
	.bigproimter{
		transform: translateX(0%) !important;
		opacity: 1 !important;
		transition: all 1s ease;
	}
	.bigproim{
		transform: translateX(-50%);
		opacity: 0;
	}
	.mianproimter{
		transform: translateY(0%) !important;
		opacity: 1 !important;
		transition: all 0.75s ease;
	}
	.mainproim{
		transform: translateY(10%);
		opacity: 0;
	}
	.videopop{

	}
	.videopopcont{
		width: 100vw;
		height: 100vh;
		background: rgba(0,0,0,.38);
		position: fixed;
		top: 0;
		left: 0;
		z-index: 99;
		display: flex;
		justify-content: center;
		align-items: center;

	}
	.videopopcont{

		/* position: relative; */
	}
	.videopopcont video{
		width: 100vw;
		height: 4.2rem;
	}
	.closevi{
		font-size: 0.5rem;
		color: #fff;
		position: absolute;
		top: 4.2rem;
		right: -0.1rem;
		z-index: 99;
	}

	.supportfoo-title {
		color: #5d5f5f;
	}


	.news-list {
		padding-left: 0.3rem;
		padding-right: 0.3rem;
		box-sizing: border-box;
	}
	.news-list .ly-tabs {
		overflow: visible;
		border: 0;
	}
	.news-list .item{
		margin-left: .3rem;

		overflow: hidden;
	}
	.news-list .item:first-child {
		margin: 0;
	}
	.news-list .item .image img {
		width: 100%;
		display: block;
	}
	.news-list .item .text {
		font-size: .22rem;
		padding: .2rem .6rem .2rem .2rem;
		position: relative;

	}
	.news-list .item .text h3 {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-weight: 500;
		font-size: .3rem;

	}
	.news-list .item .text .desc {
		margin-top: 20px;
		/*height: 50px;*/
		width: 400px;
		position: relative;
		width: 100%;
	}
	.news-list .item .text .desc p {
		word-break: break-all;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
		font-size: .28rem;
	}
	.news-list .item .text .el-icon-right {
		position: absolute;
		/*right: .2rem;*/
		right: -80px;
		/*bottom: .2rem;*/
		top:10px;
	}

	#bigStar .video {
		width: 100%;
		border-radius: 20px;
		overflow: hidden;
	}
	#bigStar .you-video {
		display: block;
		width: 100%;
		height: 800px!important;
		border-radius: 0.23rem 0.23rem 0 0 ;
	}
	#bigStar .poster {
		position: relative;
	}
	#bigStar .poster .play {
		position: absolute;
		left: 50%;
		top: 50%;
		width: 200px;
		height: 200px;
		transform: translate(-50%,-50%);
	}


	.vjs-custom-skin > .video-js .vjs-big-play-button {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%,-50%);
		border-radius: 100px;
		overflow: hidden;
		background-image: url("");
	}

	.part-title {
		padding: .8rem .3rem .4rem .3rem;
		color: #5d5f5f;
		font-size: .45rem;
		text-align: center;
	}
	.latest-news.part-title {
		text-align: left;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.latest-news.part-title .more {
		font-size: .3rem;
	}
	.latest-news.part-title .more i {
		font-size: .25rem;
	}

  .phquerycont{
    /*display: flex;
    flex-direction: column;
    align-items: center;
    width: 7.5rem;
    height: 3.8rem;
    background: url(https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phquerysimg/phquerybanner.png) 100% 100%;
    background: url(https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20250721/b1768185b2a4ec4bd94b638437e64cd3.jpg) 100% 100% no-repeat;
    background-size: contain;*/
    position: relative;

  }
  .phquerycont-banner img{
    width: 100%;
  }
  .phquerycont-txt {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
  }
  .phquerycont-hea{
    font-size: 0.4rem;
    font-weight: 600;
    color: #FFFFFF;
    letter-spacing: 0.02rem;
    padding: .8rem 0 .6rem 0;
    text-align: center;
  }
  .phquerycont-title{
    font-size: 0.24rem;
    font-weight: 400;
    color: #FFFFFF;
    letter-spacing: 0.01rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 .1rem;
    text-align: center;
    line-height: 1.8;
  }
  .phquerycont-ftitle {
    font-size: 0.36rem;
    font-weight: 400;
    color: #FFFFFF;
    letter-spacing: 0.01rem;
    margin-top: 0.3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 .1rem;
    text-align: center;
    line-height: 1.4;
  }
</style>
